import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import SearchResultList from '../../../../../components/tools/SearchPage/SearchResultList';
import * as searchTypes from '../../../../../constants/searchTypes';
import { getReturnsSearchProperties, getSelectedReturn } from '../../../../../selectors/tools';
import { getSimplrAccountIdOfSelectedTicket } from '../../../../../extractFromState';
import { selectReturnFromList } from '../../../../../actions/tools/CommonInterface/Returns/AsyncReturnActions';
import { Results, ResultsHeader, ResultsHeaderColumn, ResultsHeaderRow, ResultsTable } from './SearchResults.styles';

const SearchResults = () => {
  const dispatch = useDispatch();

  const selectedReturn = useSelector(getSelectedReturn);
  const returnsSearch = useSelector(getReturnsSearchProperties);
  const simplrAccountId = useSelector(getSimplrAccountIdOfSelectedTicket);

  const returnsItemClickHandler = (orderReturn) => dispatch(selectReturnFromList(simplrAccountId, orderReturn));

  return (
    <Results key={'returnResults'}>
      {isEmpty(selectedReturn) ? (
        <ResultsHeader hide={isEmpty(returnsSearch.returns)}>
          There {returnsSearch.returns.length > 1 ? 'are' : 'is'} {returnsSearch.returns.length} return
          {returnsSearch.returns.length > 1 ? 's' : ''} associated with this order number
        </ResultsHeader>
      ) : (
        <ResultsHeader hide={isEmpty(returnsSearch.returns)}>
          Please select only the items the customer is inquiring about
        </ResultsHeader>
      )}
      <ResultsTable>
        <ResultsHeaderRow>
          <ResultsHeaderColumn width="20%">RETURN NUMBER</ResultsHeaderColumn>
          <ResultsHeaderColumn width="25%">TRACKING NUMBER</ResultsHeaderColumn>
          <ResultsHeaderColumn width="15%">STATUS</ResultsHeaderColumn>
          <ResultsHeaderColumn width="20%">CARRIER</ResultsHeaderColumn>
          <ResultsHeaderColumn width="20%">DATE</ResultsHeaderColumn>
        </ResultsHeaderRow>
        <SearchResultList
          listType={searchTypes.SEARCH_RETURNS_DECISION_TREE}
          resultList={returnsSearch.returns}
          resultClickAction={returnsItemClickHandler}
          zendeskConfig={{ isZendesk: false }}
        />
      </ResultsTable>
    </Results>
  );
};

export default SearchResults;
